import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('LovePair error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
          <div className="w-16 h-16 rounded-2xl bg-[#FFF0F3] flex items-center justify-center mb-4">
            <span className="text-3xl">💝</span>
          </div>
          <h2 className="text-lg font-bold text-[#4A2C35] mb-2">Something went wrong</h2>
          <p className="text-sm text-[#B08EA0] mb-5">Don't worry — tap below to reload.</p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            className="px-6 py-3 rounded-2xl bg-gradient-to-r from-[#FF8FAF] to-[#F4436C] text-white font-bold text-sm active:scale-95 transition-all"
          >
            Reload App
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
